"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRent = void 0;
const constants_1 = require("./constants");
const calculateRent = (size, durationMs) => {
    const rentCost = Math.ceil(constants_1.LAMPORTS_PER_EPOCH * size * (durationMs / constants_1.MS_PER_EPOCH));
    return rentCost;
};
exports.calculateRent = calculateRent;
